// Library methods

// Data
import DummyData from '../../../../components/PGConfigTab/DummyData';

// Redux Actions
import * as loaderActions from '../../../../redux/common/loader/loader.actions';
import * as pgActions from './pgConfig.actions';

// Constants
import {
    FETCH_PG_CONFIG_REQUEST,
    SAVE_PG_DETAIL_REQUEST,
    UPDATE_PG_REQUEST,
    UPDATE_PG_STATUS_REQUEST,
} from './pgConfig.constants';
import { takeLatest, put } from 'redux-saga/effects';

export function* fetchPgConfigDetails() {
    yield put(loaderActions.showLoader());
    try {
        yield put(pgActions.fetchPgConfigSuccess(DummyData));
    } catch ({ response }) {
        const { data } = response;
        yield put(pgActions.fetchPgConfigError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* savePgsDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        yield put(pgActions.savePgDetailsSuccess(payload));
    } catch (exception) {
        yield put(
            pgActions.savePgDetailsError({
                error: { errorMessage: 'Pg data does not saved' },
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* updatePgsDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, initialValues } = actions;
        yield put(pgActions.updatePgsSuccess(payload, initialValues));
    } catch (exception) {
        yield put(
            pgActions.updatePgsError({
                error: { errorMessage: 'Pg data does not updated' },
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* updatePgStatusDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        yield put(pgActions.updatePgStatusSuccess(payload));
    } catch (exception) {
        yield put(
            pgActions.updatePgStatusError({
                error: { errorMessage: 'Pg status does not updated' },
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* pgConfigDataSagas() {
    yield takeLatest(FETCH_PG_CONFIG_REQUEST, fetchPgConfigDetails);
    yield takeLatest(SAVE_PG_DETAIL_REQUEST, savePgsDetails);
    yield takeLatest(UPDATE_PG_REQUEST, updatePgsDetails);
    yield takeLatest(UPDATE_PG_STATUS_REQUEST, updatePgStatusDetails);
}
